// export const ITEM_TYPES = ["EXPENDABLE", "DURABLE"] as const;
export enum ItemType {
  EXPENDABLE = "Expendable", 
  DURABLE = "Durable"
}

